export default __webpack_public_path__ + "static/blue_fish_mobile-57f6c306513ba654adc51d0e263a4f26.png";